import { render, staticRenderFns } from "./ObjectManagementList.vue?vue&type=template&id=000d43ca&scoped=true"
import script from "./ObjectManagementList.vue?vue&type=script&lang=js"
export * from "./ObjectManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d43ca",
  null
  
)

export default component.exports